import ScrollReveal from 'scrollreveal';

window.sr = ScrollReveal({
    duration: 750,
    easing: 'cubic-bezier(0.350, 0.365, 0.275, 0.990)',
    scale: 1,
    opacity: 0.01,
    viewOffset: {
        top: 50,
    },
});
// hide elements before render
const style = document.createElement('style');
style.innerHTML = `@media not print {.reveal,.reveal--big,.reveal--huge{opacity:0.01;}}
@media print {.reveal,.reveal--big,.reveal--huge{opacity:1 !important;}}`;
document.head.appendChild(style);
